import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const wizardModalContainer = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const wizardModal = ({ theme }: { theme: Theme }) => css`
  width: 1192px;
  max-width: 100%;
  min-width: 400px;
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 60px;
  gap: 8px;

  background-color: ${theme.palette.grey[200]};
  color: ${theme.palette.uintel.main};
`

export const wizardModalHeader = () => css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`

export const wizardModalTitle = () => css`
  display: flex;
  align-items: center;
  gap: 8px;

  h1 {
    font-size: 32px;
    line-height: 32px;
    font-weight: 700;
  }
`

export const wizardModalContent = () => css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  color: black;
  padding-top: 28px;

  > p {
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
`

export const wizardModalActionButtons = css`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;

  > * {
    padding: 8px 16px !important;
  }
`
